module.exports = __webpack_public_path__ + "static/media/lillie-win.4ca8fc93.png";